var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import BaseSubscriptionService from './BaseSubscriptionService';
import apex from '../../apex';
var PriceSubscriptionService = function (_BaseSubscriptionServ) {
  _inherits(PriceSubscriptionService, _BaseSubscriptionServ);
  function PriceSubscriptionService() {
    _classCallCheck(this, PriceSubscriptionService);
    return _possibleConstructorReturn(this, (PriceSubscriptionService.__proto__ || Object.getPrototypeOf(PriceSubscriptionService)).apply(this, arguments));
  }
  _createClass(PriceSubscriptionService, [{
    key: 'initSubscription',
    value: function initSubscription(req, callback) {
      apex.connection.RPCCall('SubscribePrices', req, function () {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        try {
          data = JSON.parse(data.o);
          callback(data);
        } catch (e) {
          console.error('Price subscription parsing data error: ', e);
        }
      });
    }
  }, {
    key: 'subscribe',
    value: function subscribe(callback) {
      this.unsubscribe();
      this.subscription = apex.connection.ws.filter(function (x) {
        return x.n === 'PriceUpdate';
      }).subscribe(function (response) {
        var updates = JSON.parse(response.o);
        callback(updates);
      });
    }
  }, {
    key: 'stopOne',
    value: function stopOne(InstrumentId) {
      apex.connection.RPCCall('UnSubscribePrices', {
        InstrumentId: InstrumentId,
        OMSId: 1
      });
    }
  }, {
    key: 'stop',
    value: function stop() {}
  }]);
  return PriceSubscriptionService;
}(BaseSubscriptionService);
export default new PriceSubscriptionService();